import { jsx, jsxs } from "react/jsx-runtime";
import React__default, { useEffect } from "react";
const globalBlockRegistry = {};
const registerBlockComponent = (blockType, component) => {
  globalBlockRegistry[blockType] = component;
};
const registerBlockComponents = (blocks) => {
  Object.entries(blocks).forEach(([blockType, component]) => {
    globalBlockRegistry[blockType] = component;
  });
};
const useBlockRegistration = (blocks) => {
  useEffect(() => {
    registerBlockComponents(blocks);
  }, [blocks]);
};
const getBlockComponent = (blockType) => {
  return globalBlockRegistry[blockType] || null;
};
const hasBlockComponent = (blockType) => {
  return blockType in globalBlockRegistry;
};
const getRegisteredBlockTypes = () => {
  return Object.keys(globalBlockRegistry);
};
const renderBlock = (blockType, config = {}, key, className) => {
  const Component = getBlockComponent(blockType);
  if (!Component) {
    console.warn(`renderBlock: Block type "${blockType}" not found in registry`);
    return /* @__PURE__ */ jsx("div", { className: `p-4 border border-muted rounded-lg bg-muted/5 ${className || ""}`, children: /* @__PURE__ */ jsxs("p", { className: "text-muted-foreground text-sm", children: [
      'Block type "',
      blockType,
      '" not found'
    ] }) }, key);
  }
  return React__default.createElement(Component, {
    key,
    className,
    ...config,
    // Spread all context data as direct props
    config
    // Also keep config prop for blocks that expect it
  });
};
const clearBlockRegistry = () => {
  Object.keys(globalBlockRegistry).forEach((key) => {
    delete globalBlockRegistry[key];
  });
};
export {
  clearBlockRegistry,
  getBlockComponent,
  getRegisteredBlockTypes,
  globalBlockRegistry,
  hasBlockComponent,
  registerBlockComponent,
  registerBlockComponents,
  renderBlock,
  useBlockRegistration
};
//# sourceMappingURL=block-registry.js.map
